import colors from '../../colors';

const tooltip = {
  backgroundColor: colors.primary.darkGrey,
  borderColor: colors.primary.darkGrey,
  color: colors.primary.ltGrey2,
};

export default tooltip;
